import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export declare namespace Lucky {
    interface Info {
        id: number;
        name: string;
        start_time: string;
        end_time: string;
        /** 抽奖页面模板 */
        page_template: string;
        /** 中奖逻辑 */
        winning_logic: string;
        /** 用户获得的总抽奖数 */
        total_count: string;
        activity_id: string;
        /** 用户剩余抽奖数 */
        surplus: number;
        /** 攻略src */
        strategy: string;
        rule_url: string;
    }
    /** 获取奖品列表 */
    interface PrizeList {
        /** 奖品类型 */
        type: PrizeType;
        name: string;
        image: string;
        id: number;
    }
    type PrizeType = 'red_packet' | 'entity' | 'service';
    /** 获奖列表 */
    interface UserPrize extends PrizeList {
        /** 红包金额或者规格id */
        value: number;
        created_at: string;
    }
    /** 获取中奖列表 */
    interface Winning {
        nickname: string;
        prize_name: string;
    }
    interface LuckySpec {
        spec1_name: string | null;
        spec2_name: string | null;
        spec3_name: string | null;
        spec: LuckSku[];
    }
    interface LuckSku {
        id: number;
        spec_1: string | null;
        spec_2: string | null;
        spec_3: string | null;
        stock: number;
    }

}

export interface LuckyState {
    info: Lucky.Info | null;
    prizeList: {
        [luckyId: number]: Lucky.PrizeList[],
    };
    winning: {
        [luckyId: number]: Lucky.Winning[],
    };
    userPrize: {
        [luckyId: number]: Lucky.UserPrize[],
    };
    spec: {
        [lotteryId: number]: Lucky.LuckySpec,
    };
    skuMap: {
        [skuId: number]: Lucky.LuckSku,
    };
}

export const m: Module<LuckyState, RootState> = {
    namespaced: true,
    state: {
        info: null,
        prizeList: {},
        winning: {},
        userPrize: {},
        spec: {},
        skuMap: {},
    },
    mutations: {
        setInfo(state, info) {
            state.info = info;
        },
        setPrize(state, { lottery_id, list }) {
            Vue.set(state.prizeList, lottery_id, list);
        },
        setWinning(state, { lottery_id, list }) {
            Vue.set(state.winning, lottery_id, list);
        },
        setUserPrize(state, { lottery_id, list }) {
            Vue.set(state.userPrize, lottery_id, list);
        },
        setSpec(state, { id, spec }: {id: number; spec: Lucky.LuckySpec}) {
            Vue.set(state.spec, id, spec);
            spec.spec.forEach((ele) => {
                Vue.set(state.skuMap, ele.id, ele);
            });
        },
    },
    actions: {
        async getInfo({commit}, activity_id: string) {
            const params = {};
            if (activity_id) {
                Object.assign(params, { activity_id });
            }
            const res = await Vue.axios.get('/api/v1/lottery/info', {
                params,
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                commit('setInfo', rdata.data);
            }
            return rdata;
        },
        async getPrize({commit}, lottery_id: number) {
            const res = await Vue.axios.get('/api/v1/lottery/prize_list', {
                params: { lottery_id },
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                commit('setPrize', {
                    lottery_id,
                    list: rdata.data,
                });
            }
            return rdata;
        },
        async luckyDo(context, { lottery_id = null, count = 1 } = {}) {
            const res = await Vue.axios.get('/api/v1/lottery/do', {
                params: { lottery_id, count },
            });
            const rdata = res.data;
            return rdata;
        },
        async getWinning({commit}, lottery_id: number) {
            const res = await Vue.axios.get('/api/v1/lottery/winning', {
                params: { lottery_id, offset: 0, count: 20 },
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                commit('setWinning', {
                    lottery_id,
                    list: rdata.data,
                });
            }
            return rdata;
        },
        async getUserPrize({commit}, lottery_id: number) {
            const res = await Vue.axios.get('/api/v1/lottery/user_prize', {
                params: { lottery_id },
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                commit('setUserPrize', {
                    lottery_id,
                    list: rdata.data,
                });
            }
            return rdata;
        },
        async getSpec({commit}, id: number) {
            const res = await Vue.axios.get('/api/v1/lottery/spec', {
                params: { id },
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                commit('setSpec', {
                    id,
                    spec: rdata.data,
                });
            }
            return rdata;
        },
        async selectSpec({commit}, params: { id: number; spec_id: number }) {
            const res = await Vue.axios.post('/api/v1/lottery/spec', params);
            const rdata = res.data;
            return rdata;
        },
    },
};
